export default __webpack_public_path__ + "assets/images/ThresholdOrWatershed-a4b572b51dae6e6fc2f3bcbcef4a63e7.png";